import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess } from "./actions"
import { post } from 'helpers/api_helper'
import cookieHelper from "helpers/getCookieData"


const userLogin = async (user) => await post('/auth/login', user)

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(userLogin, {
      email: user.email,
      password: user.password,
    })
    
    if(!response.success){
      yield put(apiError('invalid login credentials'))
    } else{
      cookieHelper.setCookie("authUser", JSON.stringify({user: response.body.user}), 1)
      cookieHelper.setCookie('access_token', response.body.access_token, 1)
      cookieHelper.setCookie('refresh_token', response.body.refresh_token, 1, 7)
  
      const rawRole = response.body.user?.user_role?.name || response.body.user?.role_name || (typeof response.body.user?.role === 'string' ? response.body.user.role : '') || '';
      let userRole = rawRole.toLowerCase().trim();
      if (!userRole && response.body.user?.email?.toLowerCase().includes('patient')) {
        userRole = 'patient';
      }
      if (!userRole) {
        userRole = 'admin';
      }
      localStorage.setItem('role', userRole);
  
      yield put(loginSuccess(response.body.user))
      
      const userClinics = response.body.user?.clinic || [];
      const defaultClinic = userClinics.find(c => c.is_default === 1) || (userClinics.length === 1 ? userClinics[0] : null);

      if (defaultClinic) {
        cookieHelper.setCookie('_c', btoa(JSON.stringify(defaultClinic)), 1, 7);
        localStorage.setItem('clinic', defaultClinic?.id);
        localStorage.setItem('client', defaultClinic?.client_id);
      }

      if (userRole === 'patient') {
        history.push("/portal");
      } else if (defaultClinic) {
        history.push("/chairs");
      } else {
        history.push("/clinics");
      }
    }

  } catch (error) {
    yield put(apiError('invalid login credentials'))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    cookieHelper.deleteCookie("authUser")
    cookieHelper.deleteCookie("access_token")
    cookieHelper.deleteCookie("refresh_token")
    cookieHelper.deleteCookie("clinic")
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
